export const SWEEPSTAKES_BANNER = 'sweepstakesBanner';
export const INTERNAL_MARKETING_BANNER = 'internalMarketingBanner';
export const BENTO_HERO = 'bentoHero';
export const QUICK_LINKS = 'quickLinks';
